import { DownOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { getTagList } from "@axios/api.account";
import { TagProps } from "@axios/models";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import {
    Badge,
    Breadcrumb,
    Button,
    Cascader,
    Col,
    Dropdown,
    Empty,
    Form, FormInstance,
    Input,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Row,
    Select,
    Space,
    Spin,
    Switch,
    Table,
    notification
} from "antd";
import Column from "antd/lib/table/Column";
import React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps } from "react-router-dom";
import {
    addDeviceForMacTemplate,
    applyMacTemplate,
    authMacTemplateScopes,
    deleteDeviceForMacTemplate,
    getDeviceForMacTemplate,
    getMacTemplateScopes,
    getUnSelectedMacDevices,
    resetMacTemplateScopes,
    macTemplateExcludes,
    macTemplateResend,
    macTemplateAllDeviceExcludes,
} from "../../../axios/api.device";
import { CancelTokenSource } from "../../../axios/axios.core";
import { RootStoreModel } from "../../../redux/reducers";
import { gaEvent } from "../../../withTracker";
import { BasicStateForListModel, DeviceTypes } from "../../models";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
    isModalVisible: boolean;
    title: string;
    file: any;
    search: string;
    id: string;
    templateId: string,
    selectedRowKeys: string[],
    deviceName: string,
    orgName: string,
    tag: any,
    orgOptions: any[],
    tagOptions: any[],
    unSelectedDevices: any[],
    pageIndex2: number,
    pageSize2: number,
    totalCount2: number,
    platform: string,
    scopeType: string,
    scopeMapping: any,
    isTagModalVisible: boolean,
    isOrganizationModalVisible: boolean,
    isEdit: boolean,
    statusMapping: any,
    dropdownVisible: boolean,
    tagList: any[],
    orderBy: string,
    order: string,
    scope: string,
    category: number,
}

interface propsModel extends RouteComponentProps<any, any, any> {
    orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
    orgOptions: getOrgsOptionsSelector(state),
});

class MacAppRestrictionDevice extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            loading: false,
            columns: [],
            data: [],
            isModalVisible: false,
            title: "",
            file: "",
            search: "",
            id: "",
            templateId: this.props.match.params.id,
            selectedRowKeys:[],
            tag:"",
            orgName:"",
            deviceName:"",
            orgOptions: this.props.orgOptions,
            tagOptions:[],
            unSelectedDevices:[],
            platform: this.props.location.state?.platform,
            scopeType: "",
            scopeMapping: {"Tag": "设备组", "Organization": "全部", "Device": "设备"},
            isTagModalVisible: false,
            isOrganizationModalVisible: false,
            isEdit: false,
            statusMapping: {
                "Pending": <Translation>{t => {return t("Pending")}}</Translation>, 
                "PartialSuccess": <Translation>{t => {return t("PartialSuccess")}}</Translation>, 
                "Failed": <Translation>{t => {return t("Failed")}}</Translation>, 
                "Success": <Translation>{t => {return t("Success")}}</Translation>
            },
            dropdownVisible: false,
            tagList: [],
            orderBy: "",
            order: "",
            pageIndex2: 1,
            pageSize2: 10,
            totalCount2: 0,
            scope:"Contain",
            category: 0,
        };
    }

    cancelToken = CancelTokenSource();

    componentDidMount() {
        this.getList();
        this.getTagList();
        this.getScopes();
    }

    componentDidUpdate(prevProps: propsModel) { }

    componentWillUnmount() {
        this.cancelToken.cancel("cancel axios http request");
    }
    applyTemplateClick() {
        applyMacTemplate(this.state.templateId).then(
            () => { notification.success({ message: <Translation>{t => {return t("应用应用限制成功,时间较长请耐心等待")}}</Translation> }) }, 
            () => { notification.error({ message: <Translation>{t => {return t("应用应用限制失败")}}</Translation> }) }
        )
    }
    resetTemplateClick() {
        this.setState({loading: true, dropdownVisible: false});
        resetMacTemplateScopes(this.state.templateId).then(
            () => { notification.success({ message: <Translation>{t => {return t("重置成功")}}</Translation> }) }, 
            () => { notification.error({ message: <Translation>{t => {return t("重置失败")}}</Translation> }) },
        ).finally(
            () => {
                this.componentDidMount();
                this.setState({loading: false});
            }
        )
    }

    allExcludeClick(isExclude: boolean) {
        this.setState({loading: true, dropdownVisible: false});
        macTemplateAllDeviceExcludes(this.state.templateId, {isExcluded: isExclude}).then(
            () => { notification.success({ message: <Translation>{t => {return t("操作成功")}}</Translation> }) }, 
            () => { notification.error({ message: <Translation>{t => {return t("操作失败")}}</Translation> }) },
        ).finally(
            () => {
                this.componentDidMount();
                this.setState({loading: false});
            }
        )
    }

    onSearch = () => {
        this.getList(1);
    };
    getTagList() {
        getTagList().then(res => {
            var arr = [];
            arr = res;
            var options = [];

            for (var i = 0; i < arr.length; i++) {
                if (arr[i].values) {
                    for (var j = 0; j < arr[i].values.length; j++) {
                        options.push(arr[i].values[j])
                    }
                }
            }
            this.setState({ tagOptions: this.formatOptions(res), tagList: options, })
        })
    }
    formatOptions = (tags: TagProps[]) => {
        return tags.map(({ id, key, values }) => {
            return {
                value: id,
                label: key,
                children: values.map((item: any) => ({
                    value: item.id,
                    label: item.value,
                }))
            }
        })
    }
    getList = (
        pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize
    ) => {
        this.formRef.current?.validateFields().then((formData) => {
            const {searchName, status, organizationName, selectedTagIds} = formData;
            this.setState({ loading: true });
            getDeviceForMacTemplate(
                this.state.templateId, 
                {
                    organizationId: organizationName,
                    search: searchName,
                    status: status,
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    orderBy: this.state.orderBy,
                    order: this.state.order
                }, 
                selectedTagIds
            ).then((res) => {
                this.setState({
                    data: res.dataList,
                    pageSize: res.pageSize,
                    pageIndex: res.pageIndex,
                    totalCount: res.totalCount,
                })
            }).finally(() => {
                this.setState({loading: false});
                this.getUnSelectedDevicesList();
            })
        })
    };
    getUnSelectedDevicesList(pageIndex = this.state.pageIndex2, pageSize = this.state.pageSize2) {
        var param: any = {pageIndex, pageSize};
        if (this.state.deviceName) {
            param.search = this.state.deviceName;
        }
        if (this.state.orgName) {
            param.organizationId = this.state.orgName;
        }
        if (this.state.tag) {
            param.tagValueIds = this.state.tag;
        }
        getUnSelectedMacDevices(this.state.templateId, param).then((res: any) => {
            this.setState({
                pageIndex2: res.pageIndex,
                pageSize2: res.pageSize,
                totalCount2: res.totalCount,
                unSelectedDevices: res.dataList,
            })
        })
    }
    onDelete = (id: string) => {
        deleteDeviceForMacTemplate(this.state.templateId,{deviceIds:id}).then(c=>{
            this.getList();
        })
    };

    onOk = () => {
        this.setState({loading: true});
        var isContain = this.state.scope === "Contain" ? true : false;
        if (this.state.scopeType === "Device") {
            addDeviceForMacTemplate(
                this.state.templateId, 
                {deviceIds: this.state.selectedRowKeys, isContain: isContain}
            ).then(
                () => {
                    this.getList();
                    this.setState({tag: "", orgName: "", deviceName: ""});
                    notification.success({message: <Translation>{t => {return t("添加成功")}}</Translation>})
                },
                ()=>{ notification.error({message: <Translation>{t => {return t("添加失败")}}</Translation>}) }
            ).finally(
                () => { 
                    this.setState({isModalVisible: false, loading: false, isEdit: false});
                    this.getScopes(); 
                }
            )
        } else {
            authMacTemplateScopes(
                this.state.templateId,
                {
                    "scopeType": "Device",
                    "tagValueIds": [],
                    "organizationIds": [],
                    "deviceIds": this.state.selectedRowKeys,
                    "isContain": isContain,
                }
            ).then(
                () => {
                    this.getList();
                    this.setState({loading: false, isModalVisible: false, tag: "", orgName: "", deviceName: ""})
                },
                ()=>{ notification.error({message: <Translation>{t => {return t("添加失败")}}</Translation>}) }
            ).finally(
                () => { 
                    this.setState({loading:false});
                    this.getScopes(); 
                }
            )
        }
    };

    uploadFile = (res: any) => {
        const { fileList } = res;
        this.setState({ file: fileList[0].originFileObj });
    };

    onCancel = () => {
        this.setState({
            isModalVisible: false,
            tag: "",
            orgName: "",
            deviceName: "",
            isEdit: false
        });
    };

    onSelectChange = (selectedRowKeys:any) => {
        this.setState({ selectedRowKeys });
    };

    getScopes = () => {
        getMacTemplateScopes(this.state.templateId).then(
            (res) => {
                this.setState({scopeType: res.scopeType, category: res.category});
                this.formRef.current?.setFieldsValue({
                    Organization: res.organizationIds ? res.organizationIds[0] : "",
                    tags: res.tags,
                });
            },
            () => {
                this.setState({scopeType: "null"});
                notification.error({message: <Translation>{t => {return t("获取模板授权失败")}}</Translation>})
            }
        ).finally(
            () => { this.setState({loading: false}) }
        )
    };

    onTagOk = () => {
        this.formRef.current?.validateFields().then((res) => {
            const tags: any[] = [];
            res.tags?.forEach((item: any) => tags.push(item.tag[1])); 
            if(tags.length === 0){
                notification.error({message: <Translation>{t => {return t("请选择设备组")}}</Translation>});
                return;
            }
                                  
            authMacTemplateScopes(
                this.state.templateId,
                {
                    "scopeType": "Tag",
                    "tagValueIds": tags,
                    "organizationIds": [],
                    "deviceIds": []
                }
            ).then(
                () => {
                    this.getList();
                    this.setState({isOrganizationModalVisible: false});
                    notification.success({message: <Translation>{t => {return `${this.state.isEdit ? t("编辑成功") : t("添加成功")}`}}</Translation>});
                },
                ()=>{ notification.error({message: <Translation>{t => {return t("添加失败")}}</Translation>}) }
            ).finally(
                () => { 
                    this.setState({isTagModalVisible: false, loading: false, isEdit: false});
                    this.getScopes(); 
                }
            )
        })
    }

    onTagCancel = () => {
        this.setState({isTagModalVisible: false, loading: false, isEdit: false});
        this.formRef.current?.resetFields();
    }

    onOrganizationOk = () => {
        this.formRef.current?.validateFields().then((res) => {            
            authMacTemplateScopes(
                this.state.templateId,
                {
                    "scopeType": "Organization",
                    "tagValueIds": [],
                    //"organizationIds": [res.Organization],
                    "deviceIds": []
                }
            ).then(
                () => {
                    this.getList();
                    this.setState({isOrganizationModalVisible: false});
                    notification.success({message: <Translation>{t => {return `${this.state.isEdit ? t("编辑成功") : t("添加成功")}`}}</Translation>});
                },
                ()=>{ notification.error({message: <Translation>{t => {return t("添加失败")}}</Translation>}) }
            ).finally(
                () => { 
                    this.setState({isOrganizationModalVisible: false, loading: false, isEdit: false});
                    this.getScopes();  
                }
            )
        })    
    }

    onOrganizationCancel = () => {
        this.setState({isOrganizationModalVisible: false, loading: false, isEdit: false})
        this.formRef.current?.resetFields();
    }

    setModalStatus = (key: string) => {
        switch (key) {
            case "Device":
                this.setState({isModalVisible: true});
                break;
            case "Tag":
                this.setState({isTagModalVisible: true});
                break;
            case "Organization":
                this.setState({isOrganizationModalVisible: true});
                break;
        
            default:
                break;
        }
    }

    onResend = (deviceId: string) => {
        macTemplateResend(this.state.templateId, deviceId).then((res) => {
            notification.success({message: <Translation>{t => {return t("重新应用成功,10分钟内请不要重复操作")}}</Translation>})
        })
    }

    selectOperation = (key: string) => {
        switch (key) {
            case "applyProfile":
                this.applyTemplateClick();
                //gaEvent("templateIndex","onClick","applyTemplateClick");
                break;
            case "editProfile":
                this.props.history.push(
                    "/home/mac/appRestriction/index", 
                    this.props.history.location.state
                );
                break;
            case "resetDevice":
                this.resetTemplateClick();
                //gaEvent("templateIndex","onClick","resetTemplateClick")
                break;
        
            default:
                break;
        }
    }

    onSearchReset = () => {
        this.formRef?.current?.resetFields();
        this.getList(1);
    }

    onExclude = (checked: boolean, item: any) => {
        macTemplateExcludes(this.state.templateId, item.deviceId, {isExcluded: checked}).then(() => {
            this.getList();
            notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>})
        })
    }

    onTableChange = (pagination: any, filters: any, sorter: any, extra: any) => {
        this.setState({
            orderBy: sorter.order ? sorter.field : "",
            order: sorter.order ? sorter.order.slice(0, -3) : ""
        });
        this.getList();
    }

    render() {
        const {
            loading,
            data,
            pageSize,
            pageIndex,
            totalCount,
            isModalVisible,
            selectedRowKeys,
            orgName,
            tag,
            deviceName,
            orgOptions,
            tagOptions,
            unSelectedDevices,
            scopeType,
            scopeMapping,
            isTagModalVisible,
            isOrganizationModalVisible,
            isEdit,
            statusMapping,
            dropdownVisible,
            tagList,
            pageIndex2,
            pageSize2,
            totalCount2,
        } = this.state;
        const rowSelection = {
            selectedRowKeys:selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return (
            (<Translation>{t => {
                    return (
                        (<div>
                            <div className="breadcrumbTop py-2">
                                <Breadcrumb>
                                   
                                    <Breadcrumb.Item>{t("配置文件")}</Breadcrumb.Item>
                                    <Breadcrumb.Item><Link to={"/home/mac/appRestriction/index"}>{ t("应用限制")}</Link></Breadcrumb.Item>
                                    <Breadcrumb.Item>{t("关联设备")}</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Spin spinning={false}>
                                <Row style={{ width: "100%" }}>
                                    <div className="borderBox">
                                        <div style={{display: "flex"}}>
                                            <img src="/images/applyDevice.png" style={{width: 70, height: 70}}/>
                                            <div style={{width: "100%"}}>
                                                <Row style={{ fontSize: "16px" }}>
                                                    <Col span={18} style={{ textAlign: "left", display: "flex" }}> 
                                                        <span style={{
                                                            height: "25px",
                                                            fontSize: "18px",
                                                            fontWeight: 600,
                                                            color: "#333333",
                                                            lineHeight: "25px"
                                                        }}>{t("关联设备")}</span>
                                                    </Col>
                                                    <Col span={6} style={{ textAlign: "right" }}> 
                                                        <Dropdown
                                                            open={dropdownVisible}
                                                            onOpenChange={(visible) => { this.setState({dropdownVisible: visible}) }}
                                                            trigger={['click']}
                                                            placement="bottomCenter" 
                                                            arrow 
                                                            dropdownRender={() => (
                                                                <Menu onClick={(event) => { this.selectOperation(event.key) }}>
                                                                    {/* <Menu.Item key="applyProfile">{t("应用配置文件")}</Menu.Item> */}
                                                                    <Menu.Item key="editProfile">{t("编辑应用限制")}</Menu.Item>
                                                                    <Popconfirm 
                                                                        title={`此操作会将本应用限制的所有设备打开例外`}
                                                                        placement="bottomRight"
                                                                        onConfirm={() => { 
                                                                            this.allExcludeClick(true);
                                                                        }}
                                                                    >
                                                                        <Menu.Item key="openExclude"  className="custom-reset-menu">{t("打开全部例外")}</Menu.Item>
                                                                    </Popconfirm>
                                                                    <Popconfirm 
                                                                        title={`此操作会将本应用限制的所有设备关闭例外`}
                                                                        placement="bottomRight"
                                                                        onConfirm={() => { 
                                                                            this.allExcludeClick(false);
                                                                        }}
                                                                    >
                                                                        <Menu.Item key="closeExclude" className="custom-reset-menu">{t("关闭全部例外")}</Menu.Item>
                                                                    </Popconfirm>
                                                                    <Popconfirm 
                                                                        title={`此操作会将本应用限制从目前所有设备中移除`}
                                                                        placement="bottomRight"
                                                                        onConfirm={() => { 
                                                                            this.resetTemplateClick();
                                                                        }}
                                                                    >
                                                                        <Menu.Item key="resetDevice" danger={true} className="custom-reset-menu">{t("重置关联设备")}</Menu.Item>
                                                                    </Popconfirm>
                                                                </Menu>
                                                            )}
                                                        >
                                                            <Button type="primary"><UnorderedListOutlined /> {t("操作")}</Button>
                                                        </Dropdown>
                                                        <Button style={{marginLeft: "10px"}} onClick={() => { this.applyTemplateClick()}} type="primary">
                                                            {t("执行应用限制")}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Row style={{fontSize: "16px" }}>
                                                    <Col span={24} >
                                                        {
                                                            (scopeType && scopeType !== "null") && (
                                                                <div>
                                                                    <span style={{
                                                                        height: "18px",
                                                                        fontSize: "13px",
                                                                        fontWeight: 500,
                                                                        color: "#666666",
                                                                        lineHeight: "18px"
                                                                    }}>{t("关联设备范围")}: </span>
                                                                    {scopeType == "Organization" && <span style={{
                                                                        fontSize:"13px"
                                                                    }}>{t(scopeMapping[scopeType])}</span>}
                                                                    {scopeType != "Organization" && <a style={{
                                                                        height: "18px",
                                                                        fontSize: "13px",
                                                                        fontWeight: 500,
                                                                        color: "#3688F4",
                                                                        lineHeight: "18px",
                                                                        borderBottom: "solid",
                                                                    }} type="primary" onClick={() => {
                                                                        this.getScopes();
                                                                        this.setModalStatus(scopeType);
                                                                        this.getList();
                                                                    // }}>{scopeType === "Device" ? t("添加") : t("编辑")}</a>
                                                                    }}>{t(scopeMapping[scopeType])}</a>}
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            ((!scopeType || scopeType === "null") && scopeType !== "") && (
                                                                <Dropdown
                                                                    trigger={['click']}
                                                                    dropdownRender={() => (
                                                                        <Menu onClick={(e) => {
                                                                            this.formRef.current?.resetFields();
                                                                            // this.setState({scopeType: e.key});
                                                                            this.setModalStatus(e.key);
                                                                            this.getList();
                                                                        }}>
                                                                            <Menu.Item key={"Organization"}>{t("全部")}</Menu.Item>
                                                                            <Menu.Item key={"Tag"}>{t("设备组")}</Menu.Item>
                                                                            <Menu.Item key={"Device"}>{t("设备")}</Menu.Item>
                                                                        </Menu>
                                                                    )}
                                                                >
                                                                <Button type="primary">{t("添加设备")} <DownOutlined /></Button> 
                                                                </Dropdown>
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="borderBox">
                                        <Form ref={this.formRef} initialValues={{"status":"0"}}>
                                            <Row style={{ width: "100%" }} gutter={[8, 8]}>
                                                <Col span={6}>
                                                    <Form.Item label={t("设备信息")} name="searchName">
                                                        <Input placeholder={t("输入设备型号、名称、序列号")}></Input>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label={t("状态")} name="status">
                                                        <Select>
                                                            <Select.Option value="0">{t("全部")}</Select.Option>
                                                            <Select.Option value="Success">{t("Success")}</Select.Option>
                                                            <Select.Option value="PartialSuccess">{t("PartialSuccess")}</Select.Option>
                                                            <Select.Option value="Pending">{t("Pending")}</Select.Option>
                                                            <Select.Option value="Failed">{t("Failed")}</Select.Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                {/* <Col span={6} offset={1}>
                                                    <Form.Item label={t("全部")} name="organizationName">
                                                        <TreeSelect
                                                            showSearch
                                                            treeNodeFilterProp="title"
                                                            treeDefaultExpandAll
                                                            dropdownStyle={{ maxHeight: 400, minWidth: 100 * (orgOptions.length == 0 ? 2.5 : (orgOptions[0].maxDepth > 8 ? orgOptions[0].maxDepth / 3 : 2.5)), overflow: 'auto' }}
                                                            placeholder={t("全部")}
                                                            treeData={orgOptions}
                                                            allowClear
                                                        ></TreeSelect>
                                                    </Form.Item>
                                                </Col> */}
                                                {/* <Col span={6}>
                                                    <Form.Item label={t("标签")} name="selectedTagIds">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder={t("请选择标签")}
                                                            allowClear
                                                            style={{ width: "80%" }}
                                                        >
                                                            {
                                                                Array.isArray(tagList) ?
                                                                    tagList.map(item => (
                                                                        <Select.Option key={item.id} value={item.id} label={item.value}>{item.value}</Select.Option >
                                                                    )) : ""
                                                            }
                                                        </Select>
                                                    </Form.Item>
                                                </Col> */}
                                                <Col span={6} offset={1}>
                                                    <Form.Item>
                                                        <Space size={16}>
                                                            <Button variant="outlined" onClick={() => { this.onSearchReset();}}>
                                                                {t("重置")}
                                                            </Button>

                                                            <Button type="primary" onClick={() => { this.onSearch();}}>
                                                                {t("查询")}
                                                            </Button>
                                                        </Space>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                    <div className="borderBox">
                                        <Table
                                            size="middle"
                                            loading={loading}
                                            dataSource={data}
                                            pagination={false}
                                            onChange={this.onTableChange}
                                            rowKey={item => item.deviceId}
                                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                        >
                                            <Column
                                                key="deviceName"
                                                dataIndex="deviceName"
                                                title={t("设备名称")}
                                                sorter
                                            ></Column>
                                            <Column
                                                key="serialNo"
                                                dataIndex="serialNo"
                                                title={t("序列号")}
                                                sorter
                                            ></Column>
                                            <Column
                                                key="model"
                                                dataIndex="model"
                                                title={t("设备型号")}
                                                sorter
                                            ></Column>
                                            <Column
                                                key="userName"
                                                dataIndex="userName"
                                                title={t("用户")}
                                                sorter
                                            ></Column>
                                            <Column
                                                key="deviceType"
                                                dataIndex="deviceType"
                                                title={t("设备类型")}
                                                sorter
                                            ></Column>
                                            <Column
                                                key="platform"
                                                dataIndex="platform"
                                                title={t("平台")}
                                                sorter
                                                render={(v: string) => {
                                                    return <>{v === "IOS" ? "iOS" : v}</>
                                                }}
                                            ></Column>
                                            <Column
                                                key="osVersion"
                                                dataIndex="osVersion"
                                                title={t("系统")}
                                            ></Column>
                                            <Column
                                                key="status"
                                                dataIndex="status"
                                                title={t("状态")}
                                                render={(v: string) => {
                                                    return <>{v ? <Badge color={v === "Failed" ? "red" : "green"} text={statusMapping[v]}></Badge> : ""}</>
                                                }}
                                            ></Column>
                                            
                                            <Column
                                                key="isExcluded"
                                                dataIndex="isExcluded"
                                                title={t("例外")}
                                                sorter
                                                render={(v: boolean, item: any,index) => {
                                                    if(v){
                                                        return (
                                                            <div
                                                              id={`${item.deviceId}${index}-1`}
                                                              key={`${item.deviceId}${index}-1`}
                                                            >
                                                              <Switch 
                                                                disabled={!item.isAllowExcluded} 
                                                                defaultChecked={true} 
                                                                onChange={(checked) => { return this.onExclude(checked, item)}} 
                                                              />
                                                            </div>
                                                          );
                                                    }
                                                    else
                                                    {
                                                        return (
                                                            <div
                                                              id={`${item.deviceId}${index}-0`}
                                                              key={`${item.deviceId}${index}-0`}
                                                            >
                                                              <Switch 
                                                                disabled={!item.isAllowExcluded} 
                                                                defaultChecked={false} 
                                                                onChange={(checked) => { return this.onExclude(checked, item)}} 
                                                              />
                                                            </div>
                                                          );
                                                    }
                                                }}
                                            ></Column>
                                            <Column
                                                key="deviceId"
                                                dataIndex="deviceId"
                                                title={t("操作")}
                                                align="center"
                                                render={(v: string, d: any) => {
                                                    return (
                                                        <Space>
                                                            {
                                                                scopeType === "Device" && (
                                                                <a 
                                                                    style={{color:"#1890FF"}} 
                                                                    type="primary"  
                                                                    onClick={() => {
                                                                        this.onDelete(v);
                                                                    }}
                                                                >{t("删除")}</a>)
                                                            }
                                                            <Button 
                                                                type="link" 
                                                                style={{padding: "0 5px"}}
                                                                // hidden={!["Pending", "PartialSuccess", "Failed"].includes(d.status)} 
                                                                onClick={() => { this.onResend(v) }}
                                                            >{t("重新应用")}</Button>
                                                            <Link target="_blank" className="ant-btn ant-btn-link" style={{padding: "0 5px"}} to={`/home/devices/details/${v}`}>{t("设备详情")}</Link>
                                                        </Space>
                                                    
                                                        
                                                    );
                                                }}
                                            ></Column>
                                        </Table>
                                        <Pagination
                                            style={{ textAlign: "right", marginTop: "20px" }}
                                            pageSize={pageSize}
                                            current={pageIndex}
                                            total={totalCount}
                                            showTotal={(total, range) =>
                                                `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                            }
                                            onChange={(page, pageSize) => {
                                                this.getList(page, pageSize);
                                            }}
                                            onShowSizeChange={(current, size) => this.getList(current, size)}
                                        ></Pagination>
                                    </div>
                                </Row>
                            </Spin>
                            <Modal
                                maskClosable={false}
                                title={t("添加设备")}
                                destroyOnClose={true}
                                confirmLoading={loading}
                                open={isModalVisible}
                                width="900px"
                                onOk={() => this.onOk()}
                                onCancel={() => this.onCancel()}
                                okText={t("确认")}
                                cancelText={t("取消")}
                            >
                                <Row style={{width:"100%"}} gutter={24}>
                                    <Col span={6}>
                                        <span>范围：</span>
                                        <Select style={{width:'70%'}} value={this.state.scope} 
                                            onChange={(value: string) => {
                                                    this.setState({scope: value});
                                                }}>
                                            <Select.Option value="Contain">{t("包含所选")}</Select.Option>
                                            <Select.Option value="Exclude">{t("除外所选")}</Select.Option>
                                        </Select>
                                    </Col>
                                    <Col span={6}>
                                        <Input placeholder={t("设备名称、序列号")} value={deviceName} onChange={e=>{this.setState({deviceName: e.target.value})}}></Input>  
                                    </Col>
                                    {/* <Col span={6}>
                                    <TreeSelect
                                        showSearch
                                        treeNodeFilterProp="title"
                                        treeDefaultExpandAll
                                        style={{ width: "100%" }}
                                        dropdownStyle={{ maxHeight: 400, minWidth: 100 * (orgOptions.length == 0 ? 1.8 : (orgOptions[0].maxDepth > 8 
                                            ? orgOptions[0].maxDepth / 3 : 1.8)), overflow: 'auto' }}
                                        placeholder={t("所属部门")}
                                        value={orgName}
                                        treeData={orgOptions}
                                        onChange={(v: string) => this.setState({ orgName: v })}
                                    ></TreeSelect>
                                    </Col> */}
                                    <Col span={6}>
                                        <Cascader placeholder={t("设备组")} options={tagOptions} onChange={e=>{this.setState({tag:e[1]})}} />
                                        {/* <Input placeholder="标签" value={tag} onChange={e=>{this.setState({tag: e.target.value})}}></Input>   */}
                                    </Col>
                                    <Col span={6}>
                                        <Button type="primary" onClick={()=>{this.getUnSelectedDevicesList();}}>{t("搜索")}</Button>  
                                    </Col>
                                    <Col span={24} style={{marginTop:16}}>
                                        <Table
                                            size="middle"
                                            loading={loading}
                                            dataSource={unSelectedDevices}
                                            pagination={false}
                                            rowKey={"id"}
                                            rowSelection={rowSelection}
                                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                        >
                                            <Column
                                                key="deviceName"
                                                dataIndex="deviceName"
                                                title={t("设备名称")}
                                            ></Column>
                                            <Column
                                                key="serialNo"
                                                dataIndex="serialNo"
                                                title={t("序列号")}
                                            ></Column>
                                            <Column
                                                key="model"
                                                dataIndex="model"
                                                title={t("设备型号")}
                                            ></Column>
                                            <Column
                                                key="userName"
                                                dataIndex="userName"
                                                title={t("用户")}
                                            ></Column>
                                            {/* <Column
                                                key="organizationName"
                                                dataIndex="organizationName"
                                                title={t("所属部门")}
                                            ></Column> */}
                                            <Column
                                                key="deviceType"
                                                dataIndex="deviceType"
                                                title={t("设备类型")}
                                                render={(v) => t(DeviceTypes[v])}
                                            ></Column>
                                            <Column
                                                key="deviceType"
                                                dataIndex="deviceType"
                                                title={t("平台")}
                                            ></Column>
                                            <Column
                                                key="osVersion"
                                                dataIndex="osVersion"
                                                title={t("系统")}
                                            ></Column>
                                            <Column
                                                key="status"
                                                dataIndex="status"
                                                title={t("状态")}
                                            ></Column>
                                        </Table>
                                        <Pagination
                                            style={{ textAlign: "right", marginTop: "20px" }}
                                            pageSize={pageSize2}
                                            current={pageIndex2}
                                            total={totalCount2}
                                            showTotal={(total, range) =>
                                                `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                            }
                                            onChange={(page, pageSize) => {
                                                this.getUnSelectedDevicesList(page, pageSize);
                                            }}
                                            onShowSizeChange={(current, size) => this.getUnSelectedDevicesList(current, size)}
                                        ></Pagination>
                                    </Col>

                                </Row>
                            </Modal>
                            <Modal
                                title={`${isEdit ? t("编辑设备组") : t("添加设备组")}`}
                                maskClosable={false}
                                destroyOnClose={true}
                                confirmLoading={loading}
                                open={isTagModalVisible}
                                width="900px"
                                onOk={() => this.onTagOk()}
                                onCancel={() => this.onTagCancel()}
                                okText={t("确认")}
                                cancelText={t("取消")}
                            >
                                <Form style={{ width: "90%", marginTop: 36 }}
                                    layout="horizontal"
                                    ref={this.formRef}
                                    labelCol={{ span: 3 }}
                                >  
                                    <Form.List name="tags">
                                        {(fields, { add, remove }) => (
                                        <>
                                            {fields.map((field) => (
                                            <Form.Item key={field.key} labelCol={{ span: 3 }} label={t("设备组")}>
                                                <Row justify="space-between">
                                                <Col span="21">
                                                    <Form.Item noStyle
                                                    {...field}
                                                    name={[field.name, "tag"]}
                                                    // fieldKey={[field.fieldKey, "tag"]}
                                                    >
                                                    <Cascader options={tagOptions} placeholder={t("请选择")}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Button type="dashed" onClick={() => { remove(field.name); gaEvent("deviceAdd", "onClick", "remove") }}>-</Button>
                                                </Col>
                                                </Row>
                                            </Form.Item>
                                            ))}
                                            <Form.Item wrapperCol={{ offset: 3 }}>
                                            <Button type="dashed" onClick={() => { add(); gaEvent("deviceAdd", "onClick", "add") }} block>
                                                {t("添加设备组")}
                                            </Button>
                                            </Form.Item>
                                        </>
                                        )}
                                    </Form.List>
                                </Form>
                            </Modal>
                            <Modal
                                title={`${isEdit ? t("全部设备") : t("全部设备")}`}
                                maskClosable={false}
                                destroyOnClose={true}
                                confirmLoading={loading}
                                open={isOrganizationModalVisible}
                                width="900px"
                                onOk={() => this.onOrganizationOk()}
                                onCancel={() => this.onOrganizationCancel()}
                            >
                                <Form
                                    style={{ width: "90%", marginTop: 36 }}
                                    layout="horizontal"
                                    ref={this.formRef}
                                    // labelCol={{ span: 3 }}
                                >
                                    <p>注意：选择此范围表明当前租户下的所有设备都将使用此应用限制</p>
                                </Form>
                            </Modal>
                        </div >)
                    );
                }}</Translation>)
        );
    }
}

export default connect(mapStatetoProps, {})(MacAppRestrictionDevice);
